// Types for the hotel restaurant model (Exigences 4.1, 4.2, 4.3)

export interface HotelRestaurant {
  id?: string;
  hotel_id?: string;
  name: string;
  commercial_name: string;
  restaurant_type: string;
  status: string;
  operation_mode: string;
  // Legal
  rccm: string;
  nif: string;
  // Manager
  manager_name: string;
  manager_phone: string;
  manager_email: string;
  // Operations
  capacity: number;
  cuisine_type: string;
  opening_hours: string;
  // Services
  has_parking: boolean;
  has_wifi: boolean;
  has_ac: boolean;
  has_terrace: boolean;
  // RH
  male_employees: number;
  female_employees: number;
  // Fiscalité
  is_fpt_subject: boolean;
  fpt_rate: number;
  // Sécurité
  has_client_register: boolean;
  has_security_compliance: boolean;
  // Métadonnées
  data_source: string;
  created_at?: string;
  updated_at?: string;
  created_by?: string;
  updated_by?: string;
}

export type RestaurantErrors = Partial<Record<keyof HotelRestaurant, string>>;

export function createEmptyRestaurant(): HotelRestaurant {
  return {
    name: '',
    commercial_name: '',
    restaurant_type: '',
    status: 'active',
    operation_mode: '',
    rccm: '',
    nif: '',
    manager_name: '',
    manager_phone: '',
    manager_email: '',
    capacity: 0,
    cuisine_type: '',
    opening_hours: '',
    has_parking: false,
    has_wifi: false,
    has_ac: false,
    has_terrace: false,
    male_employees: 0,
    female_employees: 0,
    is_fpt_subject: false,
    fpt_rate: 0,
    has_client_register: false,
    has_security_compliance: false,
    data_source: 'manual',
  };
}
